import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sec844xbdh: FaireBrandEntity = {
  token: "b_sec844xbdh",
  type: "brand",
  name: "Field Kit",
  avatarUrl:
    "https://cdn.faire.com/fastly/f0c91b6a5feece3ad620f004c3a5cd043cd2d83310a1895b60bf091a39f12f5d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/43c5809d366ad1f6ea502c92674b0508e5c43b5c9f3af7508b6b9a37cc4415ac.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f0c91b6a5feece3ad620f004c3a5cd043cd2d83310a1895b60bf091a39f12f5d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/43c5809d366ad1f6ea502c92674b0508e5c43b5c9f3af7508b6b9a37cc4415ac.jpeg",
  location: "Calgary, AB, CAN",
  minimumOrderDollars: 80,
  rating: 5,
  reviewCount: 56,
  isInsider: false,
  description:
    "USMCA Complaint and not subject to US Tariffs. \n\nField Kit is an artisanal fragrance company, focused on minimal design and sustainable production. We believe that beauty and utility can be found in everyday objects and that this combination is found when goods are crafted simply and with purpose.\n \nWe blend minimal, well-designed packaging with unique, complex fragrances to create scented candles for your home. Our candles are crafted from pure soy wax, quality fragrance oils, cotton wicks, and timeless coloured glass vessels. \n\nThe design of our jars was inspired by lab-ware and vintage glass, with reuse in mind. This is one of the ways in which we practice sustainability. It’s important to us that our customers keep their Field Kit vessels and give them a second life.\n\nInspiration for our fragrances comes from a myriad of spaces, places, and experiences, drawing on the emotions and memories of the past, to tell a story. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:27.768Z",
    importedBy: "entity-db-cli",
  },
};
